import { StoreTenant } from '@/src/lib/store/types.ts';
import { Branding } from '@/src/lib/utils/branding.types.ts';

export const AUTH0_INVALID_SESSION_MESSAGE = 'user does not have a valid session';
export const AUTH0_MISSING_ACCESS_TOKEN_MESSAGE = 'missing access token';
export const AUTH0_INACTIVE_SESSION_MESSAGE = 'user does not have an active session or is not authenticated';
export const UNAUTHORIZED = 'unauthorized';
export const CUSTOMER_NOT_FOUND = 'customer does not exist';
export const CART_NEEDS_REVIEW = ' review the cart before proceeding';
export const CART_CONTAINS_NON_BUYABLE_ITEMS = 'in the cart are not currently buyable';
export const CART_PRICES_UPDATED_TRY_AGAIN_ERROR_CODE = '1714997480';
export const CART_PRICES_NOT_VALIDATED_TRY_AGAIN_ERROR_CODE = '1715156816';

export const MAIL_CONFIGURATION_NOT_VALID_ERROR_CODE = '42332423';
export const RESPONSE_CODE_EMAIL_NOT_PROVIDED = '1728917846';
export const RESPONSE_CODE_EMAIL_INVALID = '1728919034';
export const RESPONSE_CODE_PRODUCT_NOT_BUYABLE = '1730285150';
export const RESPONSE_CODE_UNABLE_CHANGE_ACCOUNTS = '1719257763';
export const RESPONSE_CODE_QUICK_ADD_INVALID_QUANTITY = '667';
export const RESPONSE_CODE_QUICK_ADD_SEPARATOR_NOT_DETECTED = '668';
export const RESPONSE_MESSAGE_FETCH_FAILED = 'fetch failed';

export const RESPONSE_CODE_STRIPE_PAYMENT_ERROR = 'payment_intent_unexpected_state';
export const RESPONSE_CODE_STRIPE_PAYMENT_AUTHENTICATION_ERROR = 'payment_intent_authentication_failure';

export const SYSTEM_PATH_CART = '/cart';
export const SYSTEM_PATH_CHECKOUT = '/checkout/';
export const SYSTEM_PATH_CUSTOMER = '/customer';
export const SYSTEM_PATH_SEARCH = '/search';
export const SYSTEM_PATHS = [SYSTEM_PATH_CART, SYSTEM_PATH_CUSTOMER, SYSTEM_PATH_SEARCH, SYSTEM_PATH_CHECKOUT];

export const AUTH0_ERROR_EMAIL_VERIFICATION_REQUIRED = 'error.email_verification_required';
export const NOTIFICATION_USER_IS_UNVERIFIED_ID = 'UNVERIFIED_USER_STATUS_NOTIFICATION_ID';

export const ERROR_CODES_TO_BE_MASKED = [MAIL_CONFIGURATION_NOT_VALID_ERROR_CODE];

export const BRANDING_ENABLED_PER_TENANT: Partial<Record<StoreTenant, Branding>> = {
  FR: Branding.TURCK_BANNER,
};

export const ERROR_CODE_TRANSLATION_MAP = new Map<string, string>([
  [RESPONSE_CODE_EMAIL_NOT_PROVIDED, 'emailNotProvided'],
  [RESPONSE_CODE_EMAIL_INVALID, 'emailInvalid'],
  [RESPONSE_CODE_PRODUCT_NOT_BUYABLE, 'productNotBuyableInCart'],
  [RESPONSE_CODE_UNABLE_CHANGE_ACCOUNTS, 'unableChangeAccounts'],
  [RESPONSE_CODE_QUICK_ADD_INVALID_QUANTITY, 'quickAddInvalidQuantity'],
  [RESPONSE_CODE_QUICK_ADD_SEPARATOR_NOT_DETECTED, 'quickAddSeparatorNotDetected'],
  [CART_PRICES_UPDATED_TRY_AGAIN_ERROR_CODE, 'pricesHaveBeenUpdatedError'],
  [RESPONSE_CODE_STRIPE_PAYMENT_ERROR, 'stripePaymentError'],
]);

export const ERROR_CODE_REDIRECT_MAP = new Map<string, string>([
  [CART_PRICES_UPDATED_TRY_AGAIN_ERROR_CODE, SYSTEM_PATH_CART],
]);
